/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from 'prop-types';
import React from 'react';
import {
  Tooltip,
  Typography,
  Icon,
  Box,
  useMediaQuery,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {
  CheckBox,
  CheckBoxOutlineBlank,
  Schedule,
} from '@mui/icons-material';
import styles from './styles';
import {
  formatDateString,
  getRelativeTime,
} from '../../utils/dateHelper';
import {
  danger,
  grey,
} from '../../utils/brandColors';
import { getCommentStringFromMentionString } from '../../utils/mentionsHelper';

import StatusBadge from '../StatusBadge';
import User from '../User';
import theme from '../../utils/theme';

export const getColorForItem = (itemList, elementId) => {
  const item = itemList.filter((i) => i.id === elementId)[0];
  return item === undefined
    ? ''
    : item.iconColor;
};

export const TaskStatusComponent = ({
  eventStatus = { status: { name: 'Unknown' } },
  color,
  icon,
  hideComment,
  hideDate,
  classes,
  showDuration,
  mini,
  archived,
  complete,
  scheduled,
  onStatusIconPress,
}) => {
  const fullscreen = useMediaQuery(theme.breakpoints.down('sm'));
  if (mini) {
    return (
      <StatusBadge
        icon={icon}
        iconColor={color}
        size={40}
        margin
        mini
      />
    );
  }
  return (
    <div>
      <div>
        <div className={classes.statusContainer}>
          <div className={classes.statusIcon} onClick={onStatusIconPress}>
            <StatusBadge
              icon={archived
                ? 'delete'
                : icon}
              iconColor={archived
                ? danger[500]
                : color}
              size={40}
              margin
            />
          </div>
          <div
            className={classes.status}
            name="status-name"
          >
            <div className={classes.statusWrapper}>
              {archived
                ? 'Deleted'
                : (eventStatus.status && eventStatus.status.name) || 'Unknown'}
            </div>
            <div className={classes.timeContainer}>
              {
                scheduled && (
                  <Box className={classes.complete} sx={{ minWidth: '105px' }}>
                    <Schedule color="primary" fontSize="inherit" className={classes.statusDurationIcon} />
                    &nbsp;Not yet started
                  </Box>
                )
              }
              {
                (complete !== undefined && !archived && !scheduled)
                && (
                  <span className={classes.complete}>
                    {
                      (complete)
                        ? <CheckBox color="primary" fontSize="inherit" className={classes.statusDurationIcon} />
                        : <CheckBoxOutlineBlank color="primary" fontSize="inherit" className={classes.statusDurationIcon} />
                    }
                    &nbsp;{
                      (complete)
                        ? 'Complete'
                        : 'Incomplete'
                    }
                  </span>
                )
              }
              {
                (!archived && !hideDate && !scheduled)
                && <span className={classes.statusDate}>{formatDateString(eventStatus.createdDate)}</span>
              }
              {
                (!archived && !!showDuration && !scheduled && !fullscreen)
                && (
                  <span className={classes.duration}>
                    {
                      (
                        !eventStatus.nextEventStatus
                        || !eventStatus.nextEventStatus.createdDate
                      )
                        ? <Icon fontSize="inherit" className={classes.statusDurationIcon}>alarm</Icon>
                        : <Icon fontSize="inherit" className={classes.statusDurationIcon}>alarm_on</Icon>
                    }
                    &nbsp;{getRelativeTime(eventStatus.createdDate, (eventStatus.nextEventStatus || {}).createdDate)}
                  </span>
                )
              }
              {
                archived && <span className={classes.statusDate}>This task has been deleted.</span>
              }
            </div>

            {
              !hideComment
              && eventStatus.statusComment
              && eventStatus.statusComment.length > 0
              && !fullscreen
              && (
                <Tooltip title={<div>{eventStatus.createdByEmail}: {getCommentStringFromMentionString(eventStatus.statusComment)}</div>}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      my: 0.5,
                    }}
                  >
                    <User
                      mini
                      size={24}
                      user={{
                        email: eventStatus.createdByEmail,
                        userFullName: eventStatus.createdBy,
                      }}
                      className={classes.commentIcon}
                    />
                    <Typography
                      sx={{
                        fontSize: '12px',
                        ml: 1,
                        color: grey.main,
                        maxWidth: 300,
                      }}
                      noWrap
                      component="div"
                    >
                      {
                        getCommentStringFromMentionString(eventStatus.statusComment)
                      }
                    </Typography>
                  </Box>
                </Tooltip>
              )
            }
          </div>
        </div>
      </div>
      {/* TODO create popover to replace tooltip
            component with more details and a white/clean background  */}
    </div>
  );
};

TaskStatusComponent.propTypes = {
  eventStatus: PropTypes.object,
  classes: PropTypes.object,
  color: PropTypes.string,
  icon: PropTypes.string,
  hideComment: PropTypes.bool,
  hideDate: PropTypes.bool,
  showDuration: PropTypes.bool,
  mini: PropTypes.bool,
  archived: PropTypes.bool,
  complete: PropTypes.bool,
  scheduled: PropTypes.bool,
  onStatusIconPress: PropTypes.func,
};

TaskStatusComponent.defaultProps = {
  eventStatus: { nextEventStatus: {} },
  classes: {},
  color: '',
  icon: '',
  hideComment: false,
  hideDate: false,
  showDuration: true,
  mini: false,
  archived: false,
  complete: undefined,
  scheduled: false,
  onStatusIconPress: () => { },
};

export default withStyles(styles)(TaskStatusComponent);
